let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8T9rB")).then(() => parcelRequire('9v70N'));